import { Fragment, useState, useRef } from 'react';
import { wrapIframes, urlWithParams } from '../../../services/Util';
import styled from 'styled-components';
import Modal from '../Partials/Modal';
import { Link, useHistory } from 'react-router-dom';

export default function ConvertkitModal({ page }) {
	const [isSubscribed, setIsSubscribed] = useState(false);
	const [email, setEmail] = useState('');

	const emailInput = useRef();

	const { __ } = wp.i18n;
	const history = useHistory();

	const button = page.buttons.find((b) => {
		return 'Convertkit' === b.type;
	});

	if (!button) {
		return;
	}

	const {
		id,
		label,
		feature,
		animate = 'wiggle',
		animateDuration,
		flagLabel,
		backgroundColor,
		textColor,
		APIKey,
		listId,
		valueIsSet = false,
		welcomeMessage = '',
		successMessage = '',
	} = button;

	if (
		(!label || !label.length || !APIKey || !APIKey.length || !listId || !listId.length) &&
		!valueIsSet
	) {
		return false;
	}

	function onEmailUpdate(e) {
		setEmail(e.target.value);
	}

	function doSubscribe(e) {
		const { current: emailCurrent } = emailInput;

		if (!email.length) {
			emailCurrent.focus();
			return false;
		}

		window.jQuery
			.post(window.social_link_pages.admin_ajax, {
				action: 'social_link_pages_Convertkit_subscribe',
				email: email,
				page_id: page.id,
				button_id: id,
				_wpnonce: document.getElementById('social_link_pages_wpnonce').value,
			})
			.always((response) => {
				setIsSubscribed(true);

				setTimeout(() => {
					history.push(urlWithParams({ m: '' }));
				}, 4000);
			});
	}

	return (
		<Modal title={label}>
			{welcomeMessage && !isSubscribed && (
				<div dangerouslySetInnerHTML={{ __html: wrapIframes(welcomeMessage) }}></div>
			)}

			{isSubscribed && (
				<div dangerouslySetInnerHTML={{ __html: wrapIframes(successMessage) }}></div>
			)}

			{!isSubscribed && (
				<div className="input-group mb-3">
					<input
						type="text"
						className="form-control"
						ref={emailInput}
						onChange={onEmailUpdate}
						defaultValue={email}
						autoComplete="off"
						placeholder={__('Enter your email address', 'social-link-pages')}
					/>
					<div className="input-group-append">
						<button className="btn" type="button" onClick={doSubscribe}>
							{__('Join', 'social-link-pages')}
						</button>
					</div>
				</div>
			)}
		</Modal>
	);
}

const StyledButton = styled.a`
	${(props) =>
		'' !== props.backgroundColor ? `background: rgb(${props.backgroundColor}) !important;` : ''}
	${(props) => ('' !== props.textColor ? `color: rgb(${props.textColor}) !important;` : '')}
	position: relative;
`;

const StyledFlag = styled.span`
	position: absolute;
	right: -0.618rem;
	top: -0.618rem;
	transform: rotate(8deg);

	i {
		background: gold;
		border-radius: 0.382rem;
		color: black;
		font-size: 0.82rem;
		padding: 0.236rem 0.618rem;
	}

	svg {
		fill: gold !important;
		margin-right: 0.5rem;
		margin-top: -0.5rem;
	}
`;
